export default __webpack_public_path__ + "static/media/animals.a7477019.png";